import { createSelector } from 'reselect';

const data = (state) => state.warningModel;

export const selectWarningModelProps = createSelector([data], (token) => token);
export const selectWarningModelShow = createSelector([data], (model) => model.show);
